module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_FR.419ae28a.txt";